import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useParams, useLocation } from 'react-router-dom';


function TenantPage() {
    const { tenantName } = useParams();
    const location = useLocation();
    const navigate = useNavigate(); 
    const customer = location.state?.customer;

    return (
        <div className='flex items-center justify-center mt-20'>
            <div className="w-2/3 p-6 bg-white shadow-md rounded-lg mx-auto"> 
                <h2 className="text-2xl font-bold mb-4 text-start">Add New Tenant</h2>
                <p>Customer ID: {tenantName}</p>
                <p>Customer: {customer}</p>
                
            </div>
        </div>
    );
}

export default TenantPage;
